export const mergeArraysBy = (arr1 = [], arr2 = [], isValidFn = () => true) => {
    let j = 0;

    const merged = arr1.map(item1 => (isValidFn(item1)
        ? item1
        : arr2[j++] || item1));

    return merged.concat(arr2.slice(j));
};
